import {
  getService,
  TenantService,
  instance,
  AuthService,
} from '@seismic/browser-services';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';
import sds from 'utils/sds';
import jwtDecode from 'jwt-decode';
import { getSeismicAuthToken } from './centralAuthToken';

const isJointUser = async () => {
  try {
    const { jointUser } = await request.get(routes.SEISMIC.JOINT_USER);
    return jointUser;
  } catch {
    return false;
  }
};

export const setSeismicAuthService = token => {
  const authService = getService(AuthService);
  authService.setAccessToken(`Bearer ${token}`);
};

const setupBrowserServices = async (tenantDomain, tenantName) => {
  await getService(TenantService).initTenantInfoByDomain(tenantDomain);
  instance.setSubdomain(tenantName); // this will not be needed on a later version of seismic-browser-services
};

const getRemainingTokenTime = token => {
  const { exp } = jwtDecode(token);
  const now = new Date();
  const expDate = new Date(exp * 1000);
  const diff = expDate - now;
  return diff > 0 ? diff : 0;
};

const setRefreshTokenInterval = async () => {
  const token = await getSeismicAuthToken();
  if (token) {
    setTimeout(setRefreshTokenInterval, getRemainingTokenTime(token));
  }
};

// browser services setup - This is needed to get integrated with the UUC from Seismic
window.addEventListener('DOMContentLoaded', async () => {
  // eslint-disable-next-line no-underscore-dangle
  const tenant = global?.__LLY_TENANT__?.name || global?.__LLY_TENANT__?.id;

  if (!tenant || !(await isJointUser())) {
    return;
  }

  const [token, { tenantName, tenantDomain }] = await Promise.all([
    getSeismicAuthToken(),
    sds.getTenantInfo(tenant),
  ]);

  if (!token || !tenantDomain || !tenantName) {
    return;
  }

  await setupBrowserServices(tenantDomain, tenantName);
  const { hostname } = window.location;
  //  if we are not in the iframe, replace the token when the auth token is set to expire
  if (
    !hostname.endsWith('seismic.com') &&
    !hostname.endsWith('seismic-dev.com')
  ) {
    setTimeout(setRefreshTokenInterval, getRemainingTokenTime(token));
  }
});
